import { useParams, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const Payment = () => {
  const { status } = useParams()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const isSuccessful = status === 'successful'

  return (
    <div className="container checkout-container">
      <div
        className="container bb-color p-4"
        style={{  width: '100%', height: 'auto', gap: '1.2rem', borderRadius: '12px' }}
      >
        <div>
          <h5 className="bld-900" style={{ marginBottom: '0.5rem' }}>
            {isSuccessful ? t('Payment Processing!') : t('Payment Failed')}
          </h5>
          <p style={{ fontSize: '0.95rem', opacity: 0.85, margin: 0 }}>
            {isSuccessful
              ? t('Your transaction is currently being processed. Your benefits will be activated immediately upon successful confirmation. Thank you for your patience.')
              : t("We couldn't process your payment. Please check your card details and try again. If the issue persists, contact your bank or reach out to our support team.")
            }
          </p>
        </div>

        <div className="mebership-button w-100 text-center">
          <button
            className="main-btn tb-color p-color "
            onClick={() => navigate(isSuccessful ? '/my-profile' : '/membership-credits')}
          >
            {isSuccessful ? t('Go to My Profile') : t('Try again')}
          </button>
        </div>

      </div>
    </div>
  )
}

export default Payment
